import { useMemo } from 'react';
import { useListUsers as useListUsersApi } from '@/shared/api/generated/users';
import { Technician } from '../model';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserListResponse } from '@/shared/api';

type UseTechniciansOptions = {
  query?: Partial<UseQueryOptions<UserListResponse>>;
};

const emptyTechnicians: Technician[] = [];

export const useTechnicians = (options?: UseTechniciansOptions) => {
  const query = useListUsersApi({ role: 'technician' }, options);

  const technicians = useMemo(() => {
    return query.data?.map((userData) => new Technician(userData)) ?? emptyTechnicians;
  }, [query.data]);

  return {
    ...query,
    data: technicians,
  };
};
